
import { defineComponent, PropType, toRef } from 'vue';
import { useVModel } from 'vue-composable';
import { Material } from '@/types/app';
import { useStore } from '@/store';
import { formDefaults, metricConversionRates } from '@/constants';
import { addOrEditHeader, useAddEditFormState } from '@/utils';
import AppModal from '@/components/modal/base/AppModal.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import NumberInput from '@/components/form-controls/base/NumberInput.vue';
import DefaultOrCustomValueInput from '@/components/form-controls/DefaultOrCustomValueNumberInput.vue';

export default defineComponent({
  name: 'MaterialAddEditFormModal',
  emits: ['update:openState'],
  components: {
    AppModal,
    TextInput,
    NumberInput,
    DefaultOrCustomValueInput
  },
  props: {
    openState: {
      type: Boolean,
      required: true
    },
    material: {
      type: Object as PropType<Material>
    }
  },
  setup(props) {
    const isOpen = useVModel(props, 'openState');
    const header = addOrEditHeader(toRef(props, 'material'));

    const store = useStore();
    const materialState = useAddEditFormState(
      toRef(props, 'material'),
      formDefaults.material,
      store.dispatch.materials.update,
      store.dispatch.materials.create
    );

    return {
      isOpen,
      header,
      materialState,
      metricConversionRates
    };
  }
});
